import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

type ComponentFaq = {
  __typename: "ComponentFaq";
  itemsCollection: {
    items: { question: string; answer: { json: Document } }[];
  };
};

const isComponentFaq = (component: any): component is ComponentFaq => {
  return component?.__typename === "ComponentFaq";
};

export const FaqStructuredData = ({
  components,
}: {
  components: ({ __typename: string } | ComponentFaq)[];
}) => {
  const faqItems = components
    .filter(isComponentFaq)
    .flatMap((component) => component?.itemsCollection?.items ?? []);

  if (faqItems.length === 0) {
    return null;
  }

  const faqs = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: documentToHtmlString(item.answer.json),
        },
      };
    }),
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: faqs }}
    ></script>
  );
};
